module.exports = __webpack_public_path__ + "img/image (10).9c9560ac.png";